import type { GameManifest } from "../../contracts/game";

export const sectorTraderManifest: GameManifest = {
  id: "sector-trader",
  title: "Sector Trader",
  version: "0.1.0",
  status: "playable",
  coverAsset: "/covers/sector-trader.svg",
  catalogOrder: 8,
  preferredAspectRatio: 1254 / 784,
  supportsCpu: false,
  offline: "capable",
  load: () => import("./index"),
};
